import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueCustomElement from "vue-custom-element";
import { VueMaskDirective } from "v-mask";

import { createPinia, PiniaVuePlugin } from "pinia";

import PrimeVue from "primevue/config";
// import "primevue/resources/themes/lara-light-blue/theme.css";
import "./assets/styles/theme.scss";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Steps from "primevue/steps";
import Dropdown from "primevue/dropdown";
import Divider from "primevue/divider";
import AutoComplete from "primevue/autocomplete";
import RadioButton from "primevue/radiobutton";
import SelectButton from "primevue/selectbutton";
import ToggleButton from "primevue/togglebutton";
import InputNumber from "primevue/inputnumber";
import InputMask from "primevue/inputmask";
import Checkbox from "primevue/checkbox";
import Calendar from "primevue/calendar";
import Message from "primevue/message";
import Textarea from "primevue/textarea";
import Carousel from "primevue/carousel";
import Galleria from "primevue/galleria";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import OverlayPanel from "primevue/overlaypanel";
import MultiSelect from "primevue/multiselect";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

Vue.config.productionTip = false;

/* eslint-disable */
Vue.use(PrimeVue);

Vue.component("InputText", InputText);
Vue.component("Button", Button);
Vue.component("Steps", Steps);
Vue.component("Dropdown", Dropdown);
Vue.component("Divider", Divider);
Vue.component("AutoComplete", AutoComplete);
Vue.component("RadioButton", RadioButton);
Vue.component("SelectButton", SelectButton);
Vue.component("ToggleButton", ToggleButton);
Vue.component("InputNumber", InputNumber);
Vue.component("InputMask", InputMask);
Vue.component("Checkbox", Checkbox);
Vue.component("Calendar", Calendar);
Vue.component("Message", Message);
Vue.component("Textarea", Textarea);
Vue.component("Carousel", Carousel);
Vue.component("Galleria", Galleria);
Vue.component("Accordion", Accordion);
Vue.component("AccordionTab", AccordionTab);
Vue.component("TabView", TabView);
Vue.component("TabPanel", TabPanel);
Vue.component("OverlayPanel", OverlayPanel);
Vue.component("MultiSelect", MultiSelect);
Vue.component("DataTable", DataTable);
Vue.component("Column", Column);

Vue.directive("mask", VueMaskDirective);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.use(VueCustomElement);

Vue.customElement("pllenty-form", App, {
	beforeCreateVueInstance(root) {
		root.router = router;
		root.pinia = pinia;
		root.PrimeVue = PrimeVue;

		return root;
	},

	props: ["formName", "testMode"],
});
